import { DESKTOP } from "@/themes/device";
import styled from "@emotion/styled";
import {
  grayScale,
  mBody2,
  mTitle2,
  wBody1,
  wBody2,
  wTitle2,
  wTitle3,
} from "@teamsparta/design-system";

export const Card = styled.article<{ variation: string }>`
  width: 100%;
  background-color: ${grayScale.white};
  padding: 24px 20px;
  border-radius: 8px;

  ${DESKTOP} {
    padding: 32px 24px;
  }
`;

export const Desc = styled.p`
  ${mTitle2};
  color: ${grayScale.gray80};
  font-weight: 500;
  margin: 18px 0 14px 0;

  b {
    color: ${grayScale.gray90};
    font-weight: 700;
  }

  ${DESKTOP} {
    ${wBody1};
    font-weight: 500;
    font-size: 18px;
    color: ${grayScale.gray80};
  }
`;

export const MarketerType = styled.small`
  ${mBody2}
  color: ${grayScale.gray70};
  font-weight: 500;

  ${DESKTOP} {
    ${wBody2}
    color: ${grayScale.gray70};
  }
`;
